import { app } from './app'

app.$mount('#app')


// WEBPACK FOOTER //
// ./src/main.js